import { useNavigate } from "react-router-dom";

const CompanyRefer = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 font-sans overflow-hidden">
      {/* Header */}
      {/* <div className="w-screen h-64 md:h-[600px] border-[3px] border-[#35A93E]">
        <img
          src="/network-marketing.jpeg"
          alt="Network Marketing Banner"
          className="w-full h-full object-contain md:object-cover"
        />
      </div> */}

      {/* Main Content */}
      <main className="container mx-auto px-4 py-12">
        {/* Hero Section */}
        <section className="bg-white rounded-2xl shadow-xl p-8 mb-10 text-center transform hover:scale-[1.01] transition-transform duration-300">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Member Networking for Sales
          </h2>
          <h3 className="text-2xl font-semibold text-gray-800 mb-4">
            Network Marketing Partner
          </h3>
          <p className="text-gray-600 leading-relaxed max-w-2xl mx-auto">
            <strong>Opportunity:</strong> Earn commissions by connecting people
            and expanding the LifeOnPlus network.
            <br />
            <strong>How It Works:</strong> By referring new customers and
            partners, you can earn commissions based on their activities,
            helping you build a steady income stream.
            <br />
            <strong>Who It’s For:</strong> Individuals looking for a
            performance-based model with the potential for significant earnings
            through referrals.
          </p>
          <a
            onClick={() =>
              navigate("/signup/member", { state: { openMemberSignUp: true } })
            }
            className="mt-6 inline-block bg-[#35A93E] text-white font-semibold px-8 py-3 rounded-full hover:bg-green-700 transition-colors duration-300"
          >
            Become a Network Partner
          </a>
        </section>

        {/* Product USP Section */}
        <section className="bg-gradient-to-r from-[#35A93E] to-green-500 text-white rounded-2xl shadow-xl p-8 mb-10">
          <h2 className="text-3xl font-bold mb-6 text-center">Product USP</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-2xl font-semibold mb-2">Unique Offering</div>
              <p className="text-sm">No direct competitors.</p>
            </div>
            <div className="text-center">
              <div className="text-2xl font-semibold mb-2">
                Prospective Clients
              </div>
              <p className="text-sm">Even Human life (Global Population).</p>
            </div>
            <div className="text-center">
              <div className="text-2xl font-semibold mb-2">
                Growth Potential
              </div>
              <p className="text-sm">100% scalability.</p>
            </div>
          </div>
          <p className="text-center mt-4 text-sm italic">
            Please Note: (Earnings Differ on Each Vertical of Business offered
            for Sale)
          </p>
        </section>

        {/* Types of Income Section */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
            Types of Income (For Sale of Global Digital Health Smart Card)
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                Direct Income
              </h3>
              <p className="text-gray-600">
                Fixed Commission on every direct sale - 20%.
              </p>
            </div>
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                Referral Commissions
              </h3>
              <p className="text-gray-600">
                Earn through Referral Commissions.
              </p>
            </div>
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                Level Income
              </h3>
              <p className="text-gray-600">Earn through Level Income.</p>
            </div>
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                Bonus Income
              </h3>
              <p className="text-gray-600">Earn through Bonus Income.</p>
            </div>
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                Rank and Reward Income
              </h3>
              <p className="text-gray-600">
                Climb the ranks and unlock exclusive rewards based on annual
                business volume. (Cash bonuses- Luxury cars-International
                Trips-Top Tier Incentives) (Refer Table C)
              </p>
            </div>
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                Re-Purchase Plan Incentive
              </h3>
              <p className="text-gray-600">
                30% of the re-purchase value is distributed equally among the
                first 10 Upline levels. (Example: if the re-purchase value is
                Rs.1000, then Rs.300 is distributed, as Rs.30 to each level of
                the 10 upline levels.)
              </p>
            </div>
          </div>
        </section>

        {/* Group Business Incentives Section */}
        <section className="bg-white rounded-2xl shadow-xl p-8 mb-10">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
            Group Business Incentives (Month wise)
          </h2>
          <p className="text-center text-gray-600 mb-6">
            Monthly incentives based on group business volume
          </p>
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-[#35A93E] text-white">
                  <th className="p-4">Direct Members</th>
                  <th className="p-4">Group Business Volume</th>
                  <th className="p-4">Incentives</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="p-4">30</td>
                  <td className="p-4">5L</td>
                  <td className="p-4">Smart watch</td>
                </tr>
                <tr className="border-b">
                  <td className="p-4">30</td>
                  <td className="p-4">10L</td>
                  <td className="p-4">iPhone</td>
                </tr>
                <tr className="border-b">
                  <td className="p-4">30</td>
                  <td className="p-4">20L</td>
                  <td className="p-4">Electric Scooter</td>
                </tr>
                <tr className="border-b">
                  <td className="p-4">30</td>
                  <td className="p-4">30L</td>
                  <td className="p-4">Nano Car</td>
                </tr>
                <tr className="border-b">
                  <td className="p-4">60</td>
                  <td className="p-4">1 CR</td>
                  <td className="p-4">Car</td>
                </tr>
                <tr className="border-b">
                  <td className="p-4">80</td>
                  <td className="p-4">1.5 CR</td>
                  <td className="p-4">100 gm Gold & iPhone</td>
                </tr>
                <tr>
                  <td className="p-4">100</td>
                  <td className="p-4">2.5 CR</td>
                  <td className="p-4">Car & 100 gm Gold</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Best Performance Income Opportunity Section */}
        <section className="bg-gradient-to-r from-[#35A93E] to-green-500 text-white rounded-2xl shadow-xl p-8 mb-10">
          <h2 className="text-3xl font-bold mb-6 text-center">
            Best Performance Income Opportunity
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="text-center">
              <h3 className="text-xl font-semibold mb-2">
                Do 10x Business in Just 120 Hours!
              </h3>
              <p className="text-sm">
                Unlock 100% Refund on Your Investment by achieving 10 times your
                investment value within 5 days (120 hours).
              </p>
            </div>
            <div className="text-center">
              <h3 className="text-xl font-semibold mb-2">
                Climb to the Top – Join the Silver or Gold Club!
              </h3>
              <p className="text-sm">
                Hit your monthly business volume target to become a Silver or
                Gold Club Member of the Month. Enjoy additional rewards from a
                share of the company’s monthly vertical turnover, exclusively
                reserved for top-performing club members.
              </p>
            </div>
          </div>
          <div className="mt-6 overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-white text-[#35A93E]">
                  <th className="p-4">Per Month</th>
                  <th className="p-4">Silver Club</th>
                  <th className="p-4">Gold Club</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="p-4">Required Direct Active Members</td>
                  <td className="p-4">30</td>
                  <td className="p-4">60</td>
                </tr>
                <tr>
                  <td className="p-4">Incentive</td>
                  <td className="p-4">
                    1.5% of that month’s Company Turnover on this Vertical
                  </td>
                  <td className="p-4">
                    2.5% of that month’s Company Turnover on this Vertical
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Modules Section */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
            Two Modules to Earn Incentives
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                Referral Marketing (Single Level Referral Structure)
              </h3>
              <p className="text-gray-600">
                Grow your network and earn robust commissions by connecting
                people, turning every referral into a profit opportunity. Refer
                and Earn- through direct referral and single level earnings of
                20% on every direct referral as Wallet Balance-Redeemable on
                E-commerce Purchase on LifeOnPlus Website.
              </p>
            </div>
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                Level Marketing (Uni-Level)
              </h3>
              <p className="text-gray-600">
                Multi Level earnings of levels down the line up to 15 levels.
              </p>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Start Your Journey as a Referral Marketer
          </h2>
          <p className="text-gray-600 mb-6 max-w-xl mx-auto">
            Log on to{" "}
            <a
              href="https://www.lifeonplus.in"
              target="_blank"
              className="text-[#35A93E] hover:underline"
            >
              www.lifeonplus.in
            </a>{" "}
            and Sign Up As a Member to know more and to start your Journey as a
            Referral Marketer.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              onClick={() =>
                navigate("/signup/member", {
                  state: { openMemberSignUp: true },
                })
              }
              className="bg-[#35A93E] text-white font-semibold px-8 py-3 rounded-full hover:bg-green-700 transition-colors duration-300 cursor-pointer"
            >
              Sign Up Now
            </a>
            <a
              onClick={() => navigate("/signin/member")}
              className="bg-white text-[#35A93E] font-semibold px-8 py-3 rounded-full border border-[#35A93E] hover:bg-gray-100 transition-colors duration-300 cursor-pointer"
            >
              Member Login
            </a>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-[#35A93E] to-green-600 text-white py-6">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">© 2025 LifeOnPlus. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default CompanyRefer;
